module.exports = __webpack_public_path__ + "img/S Information.785139ee.png";